
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guest/booking-id",
      function () {
        return require("private-next-pages/guest/booking-id.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guest/booking-id"])
      });
    }
  